import React, { useEffect, useState, useRef } from 'react';
import { Navbar } from './../../Containers/Containers';
import NavbarTitle from './NavbarTitle';
import SearchbarContainer from '../Searchbar/Searchbar';
import { useLocation } from 'react-router-dom';
import SelectBar from './SelectBar';

const NavbarContent = () => {
  let location = useLocation();
  const inputRef = useRef(null);

  const [displaySearchbar, setDisplaySearchbar] = useState(true);
  const [moveSearcbar, setMoveSearchbar] = useState(false);
  const [currentLocation, setCurrentLocation] = useState('');
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    let currentPathName = window.location.pathname.split('/')[1];

    currentPathName.includes('terminos') ||
    currentPathName.includes('politicas') ||
    currentPathName.includes('acerca-de')
      ? setDisplaySearchbar(false)
      : setDisplaySearchbar(true);

    currentPathName.includes('gestion')
      ? setMoveSearchbar(true)
      : setMoveSearchbar(false);

    currentPathName.includes('terminos')
      ? setCurrentLocation('Términos de uso')
      : currentPathName.includes('inicio')
      ? setCurrentLocation('Inicio')
      : currentPathName.includes('favorit')
      ? setCurrentLocation('Favoritos')
      : currentPathName.includes('politica')
      ? setCurrentLocation('Política de privacidad')
      : currentPathName.includes('acerca')
      ? setCurrentLocation('Acerca de la aplicación')
      : currentPathName.includes('administrador')
      ? setCurrentLocation('Gestionar')
      : currentPathName.includes('edit')
      ? setCurrentLocation('Editar emisora')
      : currentPathName.includes('agregar')
      ? setCurrentLocation('Agregar emisora')
      : currentPathName.includes('manual')
      ? setCurrentLocation('Manual de usuario')
      : setCurrentLocation(currentPathName);

    currentPathName.includes('edit') || currentPathName.includes('agregar')
      ? setShowButton(true)
      : setShowButton(false);
  }, [location]);

  return (
    <Navbar style={{ marginTop: '0' }}>
      <NavbarTitle title={currentLocation} showIcon={showButton} />
      {displaySearchbar ? (
        <SearchbarContainer inputRef={inputRef} moveSearcbar={moveSearcbar} />
      ) : null}
      {displaySearchbar ? (
        <SelectBar inputRef={inputRef} moveSearcbar={moveSearcbar} />
      ) : null}
    </Navbar>
  );
};

export default NavbarContent;
